(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-produit-diffiseur"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dpInit) return;
    root.dataset.dpInit = '1';

    var fmt = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    };

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

    var form = root.querySelector('#dp-form');
    var idInput = root.querySelector('[data-variant-id]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];

    function renderBundles() {
      root.querySelectorAll('[data-bundle-price]').forEach(function (el) {
        var qty = parseInt(el.dataset.qty, 10);
        var disc = parseFloat(el.dataset.discount) || 0;
        var full = current.price * qty;
        var total = Math.round(full * (1 - disc / 100));
        el.innerHTML = (disc > 0 ? '<s>' + fmt(full) + '</s>' : '') + fmt(total);
      });
    }

    function renderVariant() {
      priceEl.textContent = fmt(current.price);
      if (stickyPrice) stickyPrice.textContent = fmt(current.price);
      if (compareEl) {
        compareEl.textContent = current.compare_at_price > current.price ? fmt(current.compare_at_price) : '';
      }
      idInput.value = current.id;
      atc.disabled = !current.available;
      atcLabel.textContent = current.available ? 'Ajouter au panier' : 'Épuisé';
      renderBundles();
    }

    root.querySelectorAll('.dp-option').forEach(function (fs) {
      fs.addEventListener('change', function () {
        var selected = [];
        root.querySelectorAll('.dp-option').forEach(function (f) {
          var checked = f.querySelector('input:checked');
          selected.push(checked ? checked.value : null);
          var label = f.querySelector('[data-option-label]');
          if (label && checked) label.textContent = checked.value;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] === null || o === selected[i]; });
        });
        if (match) { current = match; renderVariant(); }
      });
    });

    root.querySelectorAll('input[name="dp-qty"]').forEach(function (r) {
      r.addEventListener('change', function () {
        qtyInput.value = r.value;
        root.querySelectorAll('.dp-bundle').forEach(function (b) { b.classList.remove('is-active'); });
        r.closest('.dp-bundle').classList.add('is-active');
      });
    });

    var track = root.querySelector('[data-track]');
    var dots = root.querySelectorAll('[data-dots] i');
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    var sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(atc);
    }

    renderVariant();
  }

  function boot() { document.querySelectorAll('.dp[data-section-id]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
